import { NG_VALIDATORS } from '@angular/forms';
import { Directive, Pipe, NgModule } from '@angular/core';
import { isValid, printFormat } from 'iban';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/validator.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ValidatorService = /** @class */ (function () {
    function ValidatorService() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    ValidatorService.validateIban = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        if (c.value && !isValid(c.value)) {
            return { 'iban': { value: c.value } };
        }
        return null;
    };
    return ValidatorService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/iban-validator.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IbanValidatorDirective = /** @class */ (function () {
    function IbanValidatorDirective() {
    }
    /**
     * @param {?} c
     * @return {?}
     */
    IbanValidatorDirective.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return ValidatorService.validateIban(c);
    };
    IbanValidatorDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ibanValidator]',
                    providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidatorDirective, multi: true }]
                },] }
    ];
    return IbanValidatorDirective;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/iban-formatter.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IbanFormatterPipe = /** @class */ (function () {
    function IbanFormatterPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    IbanFormatterPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        if (isValid(value)) {
            return printFormat(value, ' ');
        }
        return value;
    };
    IbanFormatterPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ibanFormatter'
                },] }
    ];
    return IbanFormatterPipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/angular-iban.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AngularIbanModule = /** @class */ (function () {
    function AngularIbanModule() {
    }
    AngularIbanModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        IbanValidatorDirective,
                        IbanFormatterPipe
                    ],
                    imports: [],
                    exports: [
                        IbanValidatorDirective,
                        IbanFormatterPipe,
                    ]
                },] }
    ];
    return AngularIbanModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: angular-iban.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AngularIbanModule, ValidatorService, IbanValidatorDirective as ɵa, IbanFormatterPipe as ɵb };

//# sourceMappingURL=angular-iban.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-iban/fesm5/angular-iban.js
// module id = ./node_modules/angular-iban/fesm5/angular-iban.js
// module chunks = vendor